import { useEffect } from "react";
import PortfolioNav from "@/components/portfolio/PortfolioNav";
import PortfolioHero from "@/components/portfolio/PortfolioHero";
import PortfolioContent from "@/components/portfolio/PortfolioContent";
import PortfolioPricing from "@/components/portfolio/PortfolioPricing";
import PortfolioMultipolar from "@/components/portfolio/PortfolioMultipolar";
import PortfolioFaq from "@/components/portfolio/PortfolioFaq";
import PortfolioFooter from "@/components/portfolio/PortfolioFooter";

export default function Portfolio() {
  useEffect(() => {
    document.title = "OPENACCESS — Mon portefeuille en direct";
    const m = document.querySelector('meta[name="description"]');
    if (m) m.setAttribute("content", "Mon portefeuille réel : mes positions, mes mouvements, mes raisons.");
  }, []);

  return (
    <main data-testid="portfolio-page" className="relative pf-theme">
      <PortfolioNav />
      <PortfolioHero />
      <PortfolioContent />
      <PortfolioPricing />
      <PortfolioMultipolar />
      <PortfolioFaq />
      <PortfolioFooter />
    </main>
  );
}
